import LocalStorage, { LOGIN_REQUIREMENT_KEY } from '../lib/LocalStorage';
import { stringify } from 'hub-http/helpers/params';
import { loginWithGoogleAndRedirect } from './googleLogin';
import LoginDao from '../data/LoginDao';
import validateRecomendedResponse from '../utils/validateRecomendedResponse';
import { doesSupportPopup } from '../utils/browserSupport';
import { SMART_LOGIN_SELECT } from '../constants/SmartLogin';
import { loginWithSsoWithPopup } from './ssoLogin';
const loginDao = new LoginDao();
export const LoginRequirementActionTypes = {
  FETCH_LOGIN_REQUIREMENT_BEGIN: 'FETCH_LOGIN_REQUIREMENT_BEGIN',
  FETCH_LOGIN_REQUIREMENT_SUCCESS: 'FETCH_LOGIN_REQUIREMENT_SUCCESS',
  FETCH_LOGIN_REQUIREMENT_FAILURE: 'FETCH_LOGIN_REQUIREMENT_FAILURE'
};
export const fetchLoginRequirementOnLoad = (data, history, queryData) => dispatch => {
  dispatch({
    type: LoginRequirementActionTypes.FETCH_LOGIN_REQUIREMENT_BEGIN
  });
  const fetchRequirements = queryData.loginPortalId ? loginDao.getLoginRequirementWithPortal : loginDao.getLoginRequirement;
  fetchRequirements(data, queryData).then(response => {
    dispatch({
      type: LoginRequirementActionTypes.FETCH_LOGIN_REQUIREMENT_SUCCESS,
      payload: validateRecomendedResponse(response, data, queryData)
    });
    const loginRequirement = response.loginRequirement;
    LocalStorage.setJSON(LOGIN_REQUIREMENT_KEY, data);

    if (loginRequirement && (loginRequirement.loginType === 'HUBSPOT' || loginRequirement.loginType === 'MICROSOFT' || loginRequirement.loginType === 'GOOGLE' && !loginRequirement.hardRequirement)) {
      const nextPath = `${SMART_LOGIN_SELECT}${stringify(window.location.search)}`;
      history.push(nextPath);
    }
  }).catch(error => {
    dispatch({
      type: LoginRequirementActionTypes.FETCH_LOGIN_REQUIREMENT_FAILURE,
      payload: {
        error,
        isOnLoad: true
      }
    });
  });
};
export const fetchLoginRequirement = (data, history, queryData, handleError, stagedLoginRequirement) => dispatch => {
  dispatch({
    type: LoginRequirementActionTypes.FETCH_LOGIN_REQUIREMENT_BEGIN
  });
  const fetchRequirements = queryData.loginPortalId ? loginDao.getLoginRequirementWithPortal : loginDao.getLoginRequirement;
  Promise.resolve().then(() => {
    if (stagedLoginRequirement && stagedLoginRequirement.stagedEmail === data.email && stagedLoginRequirement.stagedRememberLogin === data.rememberLogin) {
      const {
        hasSsoRequirement,
        loginRequirement
      } = stagedLoginRequirement;
      return {
        hasSsoRequirement,
        loginRequirement
      };
    }

    return fetchRequirements(data, queryData);
  }).then(response => {
    dispatch({
      type: LoginRequirementActionTypes.FETCH_LOGIN_REQUIREMENT_SUCCESS,
      payload: validateRecomendedResponse(response, data, queryData)
    });
    const loginRequirement = response.loginRequirement;
    const nextPath = `${SMART_LOGIN_SELECT}${stringify(window.location.search)}`;
    LocalStorage.setJSON(LOGIN_REQUIREMENT_KEY, data);

    if (loginRequirement && loginRequirement.loginType === 'SSO' && !loginRequirement.hardRequirement && doesSupportPopup()) {
      loginWithSsoWithPopup({
        email: data.email,
        loginPortalId: loginRequirement.portalId,
        loginRedirectUrl: queryData.loginRedirectUrl,
        history
      })(dispatch);
      history.push(nextPath);
    } else if (loginRequirement && loginRequirement.loginType === 'GOOGLE' && loginRequirement.hardRequirement) {
      const credentials = {
        loginPortalId: loginRequirement.portalId,
        loginRedirectUrl: queryData.loginRedirectUrl
      };
      loginWithGoogleAndRedirect(credentials, handleError, history);
    } else {
      history.push(nextPath);
    }
  }).catch(error => {
    dispatch({
      type: LoginRequirementActionTypes.FETCH_LOGIN_REQUIREMENT_FAILURE,
      payload: error
    });
  });
};